export default __webpack_public_path__ + "static/media/blog_banner.44367a6d.png";